import React from 'react'
import {
  Field,
  Form,
  reduxForm,
  submit,
  change,
  getFormValues,
  formValueSelector
} from 'redux-form'
import { isEmpty } from 'lodash'
import { useHistory } from 'react-router-dom'
import ConfirmModal from '../modal/ConfirmModal'
import {
  buildShortText,
  buildTooltipText
} from '../../utils/childrenClassrooms'
import CustomTable from '../table/CustomTable'
import {
  createPickupAuthorizationRSPA,
  editPickupAuthorizationRSPA,
  getPickupAuthorizations,
  deleteAuthorization,
  getAuthorization
} from '../../store/pickup/actions'
import { showAlertMessage } from '../../store/alert/actions'

import { extractDayRange } from '../../utils/extractDate'
import DatePickerInput from '../shared/DatePickerInput'
import AsyncSelect from '../shared/AsyncSelect'
import ReactSelect from '../select/ReactSelect'
import { connect } from 'react-redux'
import Input from '@material-ui/core/Input'
import editSVG from '../../assets/icons/pattern-edit-icon.svg'
import deleteSVG from '../../assets/icons/pattern-delete-icon.svg'
import Button from '../../components/button/Button'
import StyledSVG from '../../components/shared/StyledSVG'
import searchIcon from '../../assets/icons/search-icon.svg'
import roundedAddIcon from '../../assets/icons/rounded-add-cross-icon.svg'

import pickupIlustration from '../../assets/icons/ilustration-pickup.svg'
import moment from 'moment'
import UserAvatar from '../shared/UserAvatar'

import { makeStyles, styled, Tooltip } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  form_root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
    fontFamily: 'Montserrat, Source Sans Pro',
    alignItems: 'flex-end',
    marginTop: 56
  },
  filter_section: {
    gridColumn: 'span 8',
    display: 'flex',
    flexDirection: 'column',
    rowGap: 56
  },
  filter_section_wrapper: {},
  filter_section_first_row: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: 32
  },
  filter_section_second_row: {
    display: 'flex',
    gap: 32
  },
  search_component: {
    width: '100%',
    height: 40,
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid #D2D5D8',
    '& input': {
      padding: 0
    }
  },
  create_btn: {
    backgroundColor: '#00ACDB',
    height: 48,
    padding: '12px 48px',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#00ACDB'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    lineHeight: '19.5px',
    '& .label_wrapper': {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      '& p': {
        margin: 0
      }
    }
  },
  ilustration_section: {
    gridColumn: 'span 4',
    height: 160,
    backgroundImage: `url(${pickupIlustration})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain'
  },
  search_field: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 8,
    height: 'fit-content',
    '& p.label': {
      margin: 0,
      fontSize: 12,
      fontWeight: 600
    }
  },
  date: {
    '& .MuiInputAdornment-positionStart': {
      margin: '0px !important'
    },
    '& .MuiIconButton-root': {
      padding: '8px !important'
    },
    '& .MuiGrid-root': {
      width: 110
    },
    '& .MuiInputBase-root': {
      height: '40px !important'
    },
    '& input::placeholder': {
      fontSize: 12
    },
    '& .MuiInputBase-input': {
      fontSize: 12
    }
  },
  react_select: {
    width: 160,
    height: 40,
    '& .select__control': {
      height: 40,
      minHeight: 40,
      '& .select__indicators': {
        minHeight: 40
      }
    },
    '& .select__placeholder': {
      fontSize: 12
    }
  },
  date_filters: {
    display: 'flex',
    alignItems: 'center',
    gap: 16
  },
  async_select_class: {
    width: 180,
    '& .select__control': {
      height: '40px !important',
      minHeight: '40px !important'
    },
    '& .select__placeholder': {
      fontSize: '12px !important'
    },
    [theme.breakpoints.down('1400')]: {
      width: 180
    },
    [theme.breakpoints.down('1000')]: {
      width: 250
    },
    [theme.breakpoints.down('756')]: {
      width: 210
    }
  },
  table_root: {
    marginTop: 24,
    gridColumn: 'span 12'
  },
  avatar_wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    '& p': {
      fontWeight: 500,
      fontSize: 16,
      color: '#555555'
    }
  },
  actions_section: {
    display: 'flex',
    gap: 5,
    alignItems: 'center',
    '& svg': {
      '&:hover': {
        cursor: 'pointer'
      }
    },
    '& path': {
      stroke: '#868E96'
    },
    '& circle': {
      stroke: '#868E96'
    }
  },
  user_modal_root: {
    padding: '24px 32px',
    display: 'flex',
    rowGap: 32,
    flexDirection: 'column',
    alignItems: 'center'
  },
  user_modal_description: {
    '& h1': {
      color: '#386093'
    }
  },
  trash_wrapper: {
    '& svg': {
      '& path': {
        stroke: '#EF7C8F'
      }
    }
  }
}))

const InputWrapper = styled('div')(({ theme, width }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: width,
  gap: 8,
  '& p.label': {
    margin: 0,
    fontSize: 12,
    fontWeight: 600
  }
}))

const PickupTypeWrappe = styled('div')(({ theme, bgColor }) => ({
  borderRadius: 8,
  padding: 8,
  backgroundColor: bgColor,
  width: 'fit-content',
  height: 32,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& p': {
    fontSize: 16,
    fontWeight: 500
  }
}))

const SearchPickupAuthorizationsForm = ({
  handleSubmit,
  onSubmit,
  touch,
  schoolId,
  gradeValue,
  classroomValue,
  authorizationTypeValue,
  startDateValue,
  finalDateValue,
  getPickupAuthorizations,
  change,
  authorizations,
  deleteAuthorization
}) => {
  const classes = useStyles()
  const history = useHistory()
  const [nameFilter, setNameFilter] = React.useState('')
  const selectAuthorizationTypeRef = React.useRef(null)
  const selectClassroomRef = React.useRef(null)
  const selectGradeRef = React.useRef(null)
  const [deleteModal, setDeleteModal] = React.useState({
    id: null,
    open: false
  })
  const [searchParams, setSearchParams] = React.useState({})

  const authorizationType = {
    permanent: 'Autorização fixa',
    temporary: 'Somente hoje'
  }

  const columns = [
    {
      key: 'authorization_name',
      name: 'Responsável',
      width: '28%',
      render: row => {
        return (
          <div className={classes.avatar_wrapper}>
            <UserAvatar
              avatarStyle={{
                width: 40,
                height: 40
              }}
              withoutUserName
              userName={row?.name}
              avatarUrl={row?.photo_url}
            />
            <p>{row?.name}</p>
          </div>
        )
      }
    },
    {
      key: 'type',
      name: 'Tipo',
      width: '12%',
      render: row => {
        return (
          <PickupTypeWrappe
            bgColor={row?.pickup_type === 'permanent' ? '#D9E8FA' : '#F8E7D6'}
          >
            <p>{authorizationType[row?.pickup_type]}</p>
          </PickupTypeWrappe>
        )
      }
    },
    {
      key: 'children',
      name: 'Aluno(s)',
      width: '38%',
      render: row => {
        return (
          <Tooltip
            title={buildTooltipText(row?.pickup_authorization_children || [])}
          >
            <p>
              {row?.pickup_authorization_children.length > 0
                ? buildShortText(row.pickup_authorization_children, 48)
                : '-'}
            </p>
          </Tooltip>
        )
      }
    },
    {
      key: 'authorization_date',
      name: 'Cadastro',
      width: '10%',
      render: row => {
        return <p>{moment(row.created_at).format('DD/MM/YYYY')}</p>
      }
    },
    {
      key: 'actions',
      name: 'Ações',
      width: '10%',
      render: row => {
        return (
          <div className={classes.actions_section}>
            <Tooltip title='Editar'>
              <div
                onClick={() => {
                  history.push(`/pickup/authorization/${row.id}`)
                }}
              >
                <StyledSVG width={24} height={24} src={editSVG} />
              </div>
            </Tooltip>
            <Tooltip title='Excluir'>
              <div
                className={classes.trash_wrapper}
                onClick={() => {
                  handleDeleteAuthorization(row.id)
                }}
              >
                <StyledSVG width={24} height={24} src={deleteSVG} />
              </div>
            </Tooltip>
          </div>
        )
      }
    }
  ]

  React.useEffect(() => {
    getPickupAuthorizations({ page: 1 })
  }, [])

  React.useEffect(
    () => {
      const extractedInitialDate = extractDayRange(startDateValue)
      const extractedFinalDate = extractDayRange(finalDateValue)
      const newState = {
        // grade filter
        ...(gradeValue && !classroomValue
          ? {
              'q[pickup_authorization_children_child_classroom_child_classroom_grade_id_eq]': gradeValue
            }
          : {}),
        // classroom filter
        ...(classroomValue
          ? {
              'q[pickup_authorization_children_child_classroom_child_classroom_id_eq]': classroomValue
            }
          : {}),
        'q[pickup_type_eq]': authorizationTypeValue,
        ...(startDateValue
          ? {
              'q[created_at_gteq]': extractedInitialDate.beginningOfDay,
              'q[created_at_lteq]': finalDateValue
                ? extractedFinalDate.endOfDay
                : extractedInitialDate.endOfDay
            }
          : {}),
        ...(authorizationTypeValue ?? {})
      }
      if (!isEmpty(newState)) {
        setSearchParams(newState)
        getPickupAuthorizations({
          page: 1,
          params: {
            ...newState
          }
        })
      }
    },
    [
      gradeValue,
      classroomValue,
      authorizationTypeValue,
      startDateValue,
      finalDateValue
    ]
  )

  const handleChange = (event, input) => {
    const inputName = input.name
    touch(inputName)
    let newValue
    if (Array.isArray(event)) {
      newValue = event?.map(v => v)
    } else {
      newValue = event ? event.value : ''
    }
    change(input.name, newValue)
  }

  const handleDeleteAuthorization = id => {
    setDeleteModal({ id, open: true })
  }

  const handleChangeNameFilter = event => {
    setNameFilter(event.target.value)
  }

  const handleSearchByName = () => {
    getPickupAuthorizations({
      page: 1,
      params: {
        ...searchParams,
        'q[name_cont]': nameFilter
      }
    })
  }

  return (
    <Form className={classes.form_root} onSubmit={handleSubmit(onSubmit)}>
      <div className={classes.filter_section}>
        <div className={classes.filter_section_first_row}>
          <InputWrapper width='60%'>
            <p className='label'>Busca</p>
            <Input
              name={'search_name'}
              disableUnderline
              value={nameFilter}
              className={classes.search_component}
              placeholder='Busque pelo nome do responsável'
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  handleSearchByName()
                }
              }}
              onChange={e => handleChangeNameFilter(e)}
              endAdornment={
                <StyledSVG
                  style={{ marginRight: 4 }}
                  src={searchIcon}
                  width={18}
                  height={18}
                />
              }
            />
          </InputWrapper>
          <Button
            className={classes.create_btn}
            color='primary'
            type='button'
            onClick={() => {
              history.push('/pickup/authorization/create')
            }}
          >
            <div className='label_wrapper'>
              <StyledSVG src={roundedAddIcon} width={24} height={24} />
              <p>Criar nova autorização</p>
            </div>
          </Button>
        </div>
        <div className={classes.filter_section_second_row}>
          <div className={classes.search_field}>
            <p className='label'>Tipo de autorização</p>
            <Field
              component={ReactSelect}
              id='authorization_type'
              name='authorization_type'
              placeholder='Selecione o tipo da autorização'
              handleChange={handleChange}
              componentClass={classes.react_select}
              selectRef={selectAuthorizationTypeRef}
              defaultValue={authorizationTypeValue}
              touch={touch}
              isClearable
              options={[
                { label: 'Somente hoje', value: 0 },
                { label: 'Autorização fixa', value: 1 }
              ]}
            />
          </div>
          <div className={classes.search_field}>
            <p className='label'>Série</p>
            <Field
              component={AsyncSelect}
              rootStyle={classes.async_select_class}
              defaultOptions={false}
              isClearable
              id='grade_id'
              name='grade_id'
              placeholder='Selecione uma série'
              selectRef={selectGradeRef}
              handleAsyncChange={handleChange}
              searchParam='q[name_cont]'
              request={{
                path: 'grade',
                params: {
                  'q[classrooms_school_id_in]': schoolId
                }
              }}
              touch={touch}
            />
          </div>
          <div className={classes.search_field}>
            <p className='label'>Turma</p>
            <Field
              component={AsyncSelect}
              rootStyle={classes.async_select_class}
              defaultOptions={false}
              isClearable
              id='classroom_id'
              name='classroom_id'
              placeholder='Selecione uma turma'
              selectRef={selectClassroomRef}
              handleAsyncChange={handleChange}
              searchParam='q[name_cont]'
              request={{
                path: 'classroom',
                params: {
                  'q[grade_id_in]': gradeValue,
                  'q[school_id_in]': schoolId,
                  'q[year_lteq]': new Date().getFullYear() + 1,
                  'q[year_gteq]': new Date().getFullYear()
                }
              }}
              touch={touch}
            />
          </div>
          <div className={classes.date_filters}>
            <div className={`${classes.search_field} ${classes.date}`}>
              <p className='label'>Data inicial</p>
              <Field
                component={DatePickerInput}
                id='start_date'
                name='start_date'
                placeholder='00/00/00'
                disableToolbar
              />
            </div>
            <div className={`${classes.search_field} ${classes.date}`}>
              <p className='label'>Data final</p>
              <Field
                component={DatePickerInput}
                disabled={!startDateValue}
                id='final_date'
                name='final_date'
                placeholder='00/00/00'
                disableToolbar
              />
            </div>
          </div>
        </div>
      </div>
      <div className={classes.ilustration_section} />
      <div className={classes.table_root}>
        <CustomTable
          columns={columns}
          from={'authorizations'}
          data={authorizations.items}
          params={{
            ...searchParams
          }}
          fetchItems={getPickupAuthorizations}
          isFetching={authorizations.isFetching}
          pagination={authorizations.pagination}
          columnsPointer={[0]}
          border={'none'}
          headCellRadius
          headColor={'rgba(173, 184, 204, 0.3)'}
        />
      </div>
      <ConfirmModal
        title={`Tem certeza de que deseja excluir esta autorização?`}
        open={deleteModal.open}
        setOpen={value => {
          if (value) {
            setDeleteModal({ ...deleteModal, open: value })
          } else {
            setDeleteModal({
              id: null,
              open: value
            })
          }
        }}
        onConfirm={() => {
          deleteAuthorization(deleteModal.id)
        }}
      />
    </Form>
  )
}

const mapStateToProps = (state, props) => {
  const selector = formValueSelector('searchPickupAuthorizationsForm')
  return {
    userOccupations: state.auth.currentOccupation,
    fieldValues: getFormValues('searchPickupAuthorizationsForm')(state),
    currentUser: state?.auth?.user?.data,
    schoolId: state.school?.currentSchool?.school_id,
    gradeValue: selector(state, 'grade_id'),
    classroomValue: selector(state, 'classroom_id'),
    authorizationTypeValue: selector(state, 'authorization_type'),
    startDateValue: selector(state, 'start_date'),
    finalDateValue: selector(state, 'final_date'),
    authorizations: state.authorizations,
    currentAuthorization: state.authorizations.currentItem,
    initialValues: { ...state.authorizations.currentItem }
  }
}

const mapDispatchToProps = dispatch => ({
  alert: (message, type) =>
    dispatch(
      showAlertMessage({
        message: message,
        severity: type
      })
    ),
  change: (field, data) =>
    dispatch(change('searchPickupAuthorizationsForm', field, data)),
  submit: () => dispatch(submit('searchPickupAuthorizationsForm')),
  editPickupAuthorizationRSPA: data =>
    dispatch(editPickupAuthorizationRSPA.request(data)),
  createPickupAuthorizationRSPA: data =>
    dispatch(createPickupAuthorizationRSPA.request(data)),
  getPickupAuthorizations: data => dispatch(getPickupAuthorizations(data)),
  deleteAuthorization: data => dispatch(deleteAuthorization(data)),
  getAuthorizationById: data => dispatch(getAuthorization(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'searchPickupAuthorizationsForm',
    enableReinitialize: true,
    touchOnChange: true,
    touchOnBlur: true,
    onSubmit: async (values, dispatch, props) => {}
  })(SearchPickupAuthorizationsForm)
)
